import {CommonModule} from '@angular/common';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {NgModule, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpModule} from '@angular/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthGuard, buttonModule} from './shared';
import {AuthService} from './utility/auth-service';
import {NotifyService} from './utility/NotifyService';
import {ResourceBundle} from './utility/ResourceBundle';
import {SiUtil} from './utility/SiUtil';
import {ConfirmationDialogComponent} from './layout/mycomponents/shared/confirmation-dialog/confirmation-dialog.component';
import {ForgotPasswordComponent} from './layout/mycomponents/shared/forgot-password/forgot-password.component';
import {FormsModule} from '@angular/forms';
import {CookieService, CookieModule} from 'ngx-cookie';
import {PopOverModule} from './shared/modules/popover/popover.module';
import {ChangePasswordComponent} from './layout/mycomponents/shared/change-password/change-password.component';
import {ImageUploadModule} from './shared/modules/imageuploader';
import {DatePipe} from '@angular/common';
import {HttpXsrfInterceptor} from './HttpXsrfInterceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HttpClientXsrfModule} from '@angular/common/http';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ErrorInterceptor } from './utility/Error.interceptor ';
//import {GapiSession} from './layout/quotation/driveFilesLst/gapi.session';

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
    /* for development
    return new TranslateHttpLoader(
        http,
        '/start-angular/SB-Admin-BS4-Angular-6/master/dist/assets/i18n/',
        '.json'
    ); */
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

@NgModule({
    imports: [
        AppRoutingModule,
        CommonModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpModule,
               CookieModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
         buttonModule.forRoot(),
        PopOverModule.forRoot(),
        ImageUploadModule.forRoot(),
        HttpClientXsrfModule.withOptions({
            cookieName: 'X-CSRF-TOKEN',
            headerName: 'X-CSRF-TOKEN',
        }),
        NgIdleKeepaliveModule.forRoot(),
        NgxMaterialTimepickerModule
    ],
    declarations: [AppComponent, ConfirmationDialogComponent, ForgotPasswordComponent, ChangePasswordComponent,],
    providers: [AuthGuard, AuthService, NotifyService, ResourceBundle, SiUtil, DatePipe,CookieService,
                {provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true},
                { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
//    { provide: APP_INITIALIZER, useFactory: initGapi, deps: [GapiSession], multi: true },
     ],
    bootstrap: [AppComponent],
    entryComponents: [ConfirmationDialogComponent, ForgotPasswordComponent, ChangePasswordComponent],
})
export class AppModule {}

//export function initGapi(gapiSession: GapiSession) {
//  return () => gapiSession.initClient();
//}